/** Tenant organization lifecycle status (Firestore `organizations.status`). */
export enum OrganizationStatus {
  PENDING_ONBOARDING = 'PENDING_ONBOARDING',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  ARCHIVED = 'ARCHIVED'
}

/** Legacy value before SUSPENDED → DEACTIVATED migration; treat like `DEACTIVATED`. */
export const LEGACY_ORGANIZATION_STATUS_SUSPENDED = 'SUSPENDED' as const
